import React from 'react';
import { Box, FormControlLabel, Checkbox, SxProps } from '@mui/material';
import { Colors } from '../../../utils/theme';

interface IProps {
  id: string;
  label: string;
  value: boolean;
  onChange: () => void;
  disabled?: boolean;
  sx?: SxProps;
}

const CheckboxComponent: React.FunctionComponent<IProps> = ({
  id,
  label,
  value,
  onChange,
  disabled = false,
  sx
}) => {
  const labelWithoutSpaces = label.replaceAll(' ', '-');
  return (
    <FormControlLabel
      className={value ? 'checked-interest' : 'interest'}
      control={
        <Checkbox
          id={`${id}-${labelWithoutSpaces}-checkbox`}
          data-testid={`${id}-${labelWithoutSpaces}-checkbox`}
          checked={value}
          onChange={onChange}
          name={`check-${labelWithoutSpaces}`}
          color="primary"
          disabled={disabled}
          icon={
            <Box
              component="span"
              sx={{
                borderRadius: '3px',
                width: '18px',
                height: '18px',
                margin: '3px',
                backgroundColor: '#C5ECFF',
                '&:hover': {
                  backgroundColor: '#C5ECFF'
                },
                'input:disabled ~ &': {
                  boxShadow: 'none',
                  background: Colors.gray
                }
              }}
            />
          }
        />
      }
      label={label}
      sx={{
        color: Colors.main,
        ...sx
      }}
    />
  );
};

export default CheckboxComponent;
